import { render } from "./ModalCriarRequisito.vue?vue&type=template&id=227896b1&scoped=true"
import script from "./ModalCriarRequisito.vue?vue&type=script&lang=js"
export * from "./ModalCriarRequisito.vue?vue&type=script&lang=js"

import "./ModalCriarRequisito.vue?vue&type=style&index=0&id=227896b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227896b1"]])

export default __exports__